import { Component, OnInit, Input, OnChanges } from '@angular/core'; 
import {NgbActiveModal, NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-confirmation-planification',
  templateUrl: './modal-confirmation-planification.component.html',
  styleUrls: ['./modal-confirmation-planification.component.scss']
})
export class ModalConfirmationPlanificationComponent implements OnInit {
  @Input() events;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    console.log(this.events)
  }

  cancel() {
    this.activeModal.dismiss();
  }

  planifier() {
    this.activeModal.close();
  }

}
